<div class="mt-4 searchResults mx-2-5">
    <div class="flex-display">
      <div *ngIf="topic != null" class="searchTopicText bold"><span
          [innerHTML]="topic"></span>
      </div>
    </div>
    <div class="mt-1rem">
      <div class="pb-1rem" *ngIf="topicData.section != null && topicData.sectionName != null && topicData.subtopic != null && topicData.subtopicName != null">
        <div class="flex-display">
          <div *ngIf="topicData.subtopic != null && topicData.subtopicName != null"
            class="searchTopicText font-16 pdf-link content-blue text-decoration-none">{{topicData.subtopic}}&nbsp;
            <span class="pdf-link content-blue text-decoration-none" [innerHTML]="topicData.subtopicName"></span>&nbsp;<img _ngcontent-uoe-c167="" alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;</div>
          
            <div *ngIf="topicData.section != null && topicData.sectionName != null" (click)="navigateToContent()"
            class="searchTopicText font-16 pdf-link">{{topicData.section}}&nbsp;
            <span class="pdf-link" [innerHTML]="topicData.sectionName"></span></div>
        </div>
      </div>
    </div>
  </div>